let _isPerformanceApiAvailable: boolean | undefined;

// Checks if the Performance API available and using the expected API version.
export const isPerformanceApiAvailable = () => {
  // This is cached because it directly impacts performance measurements.
  if (_isPerformanceApiAvailable !== undefined) {
    return _isPerformanceApiAvailable;
  }

  try {
    // Some browsers support the Performance API but not passing an object to `measure`.
    performance.measure("isPerformanceApiAvailableTest", {
      detail: { foo: "bar" },
      start: "navigationStart",
    });
    _isPerformanceApiAvailable = true;
  } catch (error) {
    _isPerformanceApiAvailable = false;
  }

  return _isPerformanceApiAvailable;
};
